import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
//redux
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
// actions
import { loginUser, resetLoginFlag } from "../../slices/thunks";
import logoLight from "../../assets/images/logo-light.svg";
import { createSelector } from "reselect";
import ErrorAlert from "../../Components/Common/ErrorAlert";

/**
* Login component for user authentication.
* This component displays a login form, allowing users to enter their credentials
* (username and password) and sign in. It also handles form validation and dispatches
* actions for user login.
* @component
* @param {Object} props - The component props.
* @param {Object} props.history - The history object from React Router.
*/
const Login = (props) => {
	const dispatch = useDispatch();

	const loginpageData = createSelector(
		(state) => state,
		(state) => ({
			error: state.Login.error,
			loading: state.Login.loading,
			errorMsg: state.Login.errorMsg,
		})
	);
	// Inside your component
	const {
		error,
		loading,
		errorMsg
	} = useSelector(loginpageData);

	const [passwordShow, setPasswordShow] = useState(false);

	const validation = useFormik({
		// enableReinitialize : use this flag when initial values needs to be changed
		enableReinitialize: true,

		initialValues: {
			email: "",
			password: "",
		},
		validationSchema: Yup.object({
			email: Yup.string().required("Please Enter Email"),
			password: Yup.string().required("Please Enter Password"),
		}),
		onSubmit: (values) => {
			dispatch(loginUser(values, props.router.navigate));
		}
	});

	document.title = "Login | Adcropper";
	return (
		<React.Fragment>
			<ParticlesAuth>
				<div className="auth-page-content mt-lg-5 mt-xs-5 mt-sm-5">
					<Container>
						<Row>
							<Col lg={12}>
								<div className="text-center mt-sm-5 mb-4 text-white-50">
									<div>
										<Link to="/" className="d-inline-block auth-logo">
											<img src={logoLight} alt="" height="40" />
										</Link>
									</div>
								</div>
							</Col>
						</Row>

						<Row className="justify-content-center">
							<Col md={8} lg={6} xl={5}>
								<Card className="mt-4">
									<CardBody className="p-4">
										<div className="text-center mt-2">
											<h5 className="text-primary user-select-none">Welcome!</h5>
											<p className="text-muted user-select-none">Sign in to continue to Adcropper.</p>
										</div>
										<ErrorAlert errorState={error} errorMessage={errorMsg} resetError={resetLoginFlag} />
										{/* {error && error ? (<Alert className='mb-0 mt-4' color="danger"> {error} </Alert>) : null} */}
										<div className="p-2 mt-4">
											<Form
												onSubmit={(e) => {
													e.preventDefault();
													validation.handleSubmit();
													return false;
												}}
												action="#">

												<div className="mb-3">
													<Label htmlFor="email" className="form-label">Email</Label>
													<Input
														name="email"
														className="form-control"
														placeholder="Enter email"
														type="text"
														onChange={validation.handleChange}
														onBlur={validation.handleBlur}
														value={validation.values.email || ""}
														invalid={
															validation.touched.email && validation.errors.email ? true : false
														}
													/>
													{validation.touched.email && validation.errors.email ? (
														<FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
													) : null}
												</div>

												<div className="mb-3">
													<div className="float-end">
														<Link to="/forgot-password" className="text-muted">Forgot password?</Link>
													</div>
													<Label className="form-label" htmlFor="password-input">Password</Label>
													<div className="position-relative auth-pass-inputgroup mb-3">
														<Input
															name="password"
															value={validation.values.password || ""}
															type={passwordShow ? "text" : "password"}
															className="pe-5 ps-2"
															placeholder="Enter Password"
															onChange={validation.handleChange}
															onBlur={validation.handleBlur}
															invalid={
																validation.touched.password && validation.errors.password ? true : false
															}
														/>
														{validation.touched.password && validation.errors.password ? (
															<FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
														) : null}
														<button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon" onClick={() => setPasswordShow(!passwordShow)}><i className="ri-eye-fill align-middle"></i></button>
													</div>
												</div>

												<div className="form-check">
													<Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
													<Label className="form-check-label" htmlFor="auth-remember-check">Remember me</Label>
												</div>

												<div className="mt-4">
													<Button color="success" className="btn btn-success w-100" type="submit">
														Sign In
													</Button>
												</div>
											</Form>
										</div>
									</CardBody>
								</Card>

								{/* <div className="mt-4 text-center">
                                    <p className="mb-0">Don't have an account ? <Link to="/register" className="fw-semibold text-primary text-decoration-underline"> Signup </Link> </p>
                                </div> */}

							</Col>
						</Row>
					</Container>
				</div>
			</ParticlesAuth>
		</React.Fragment>
	);
};

export default withRouter(Login);